import * as THREE from 'three';
import Application from '../Application';
import { BRUNO_DESK } from './DecorMode';
const LAYOUT = [
    // Au sol, a cote du bureau.
    { name: 'plante', on: 'floor', offset: [0.95, -0.35], height: 0.95, yaw: -20 },
    // Sur le plateau. GamerSetup a libere de la place en retirant la tour
    // d'origine et le vase.
    { name: 'livres', on: 'desk', offset: [-0.33, -0.22], height: 0.22, yaw: -8 },
    { name: 'figurines', on: 'desk', offset: [-0.1, -0.3], height: 0.16, yaw: 6 },
    // Casque et Rubik's cube sont poses ici un par un ; le poste importe du
    // dossier 1 les apporte deja, a leur place d'origine sur le bureau.
    { name: 'casque', on: 'desk', offset: [0.3, 0.18], height: 0.17, yaw: 24, brunoDuplicate: true },
    { name: 'rubiks', on: 'desk', offset: [-0.2, 0.22], height: 0.07, yaw: 18, brunoDuplicate: true },
];
export default class RoomDecor {
    constructor() {
        this.group = null;
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        this.place();
    }
    /** Reglages fins sans rebuild : ?decor=0 masque tout, ?decorScale=1.2 */
    params() {
        const p = new URLSearchParams(window.location.search);
        const n = parseFloat(p.get('decorScale') || '1');
        return {
            enabled: p.get('decor') !== '0',
            scale: Number.isFinite(n) ? n : 1,
        };
    }
    place() {
        var _a;
        const { enabled, scale } = this.params();
        if (!enabled)
            return;
        const model = this.resources.items.gltfModel.roomDecorModel;
        const texture = this.resources.items.texture.roomAtlasTexture;
        const desk = this.scene.getObjectByName('desk');
        if (!model || !texture || !desk)
            return;
        texture.flipY = false;
        texture.colorSpace = THREE.SRGBColorSpace;
        const material = new THREE.MeshBasicMaterial({ map: texture });
        const deskBox = new THREE.Box3().setFromObject(desk);
        const deskSize = deskBox.getSize(new THREE.Vector3());
        const deskCenter = deskBox.getCenter(new THREE.Vector3());
        const group = new THREE.Group();
        group.name = 'room_decor';
        for (const item of LAYOUT) {
            if (BRUNO_DESK && item.brunoDuplicate)
                continue;
            const source = model.scene.getObjectByName(item.name);
            if (!source)
                continue;
            const obj = source.clone(true);
            obj.traverse((child) => {
                if (child instanceof THREE.Mesh)
                    child.material = material;
            });
            // Le clone herite des transformations du GLB : on repart de zero
            // pour que la mise a l'echelle ci-dessous soit la seule en jeu.
            obj.position.set(0, 0, 0);
            obj.rotation.set(0, 0, 0);
            obj.scale.setScalar(1);
            obj.updateMatrixWorld(true);
            // Mise a l'echelle uniforme : la hauteur voulue est exprimee en
            // fraction de la hauteur du bureau, pour que tout reste coherent
            // si la scene change d'echelle.
            const raw = new THREE.Box3().setFromObject(obj);
            const rawSize = raw.getSize(new THREE.Vector3());
            if (rawSize.y <= 0)
                continue;
            obj.scale.setScalar((deskSize.y * item.height * scale) / rawSize.y);
            obj.rotation.y = THREE.MathUtils.degToRad((_a = item.yaw) !== null && _a !== void 0 ? _a : 0);
            obj.updateMatrixWorld(true);
            // Poser : on aligne le centre horizontal sur la cible et on fait
            // reposer la base de l'objet sur le plateau ou sur le sol.
            const placed = new THREE.Box3().setFromObject(obj);
            const placedCenter = placed.getCenter(new THREE.Vector3());
            const targetX = deskCenter.x + deskSize.x * item.offset[0];
            const targetZ = deskCenter.z + deskSize.z * item.offset[1];
            const baseY = item.on === 'desk' ? deskBox.max.y : deskBox.min.y;
            obj.position.x += targetX - placedCenter.x;
            obj.position.z += targetZ - placedCenter.z;
            obj.position.y += baseY - placed.min.y;
            group.add(obj);
        }
        this.group = group;
        this.scene.add(group);
    }
}
